import { useQuery } from '@apollo/client';
import { GET_POST_PERFORMANCE_QUERY } from '../../../../graphql/resolvers/postAnalytics/getPostPerformance.gql';
import './PerformancePanel.scss';

const DASH = '—';

export default function PerformancePanel({ postId }: { postId: string }) {
  const { data, loading, error } = useQuery(GET_POST_PERFORMANCE_QUERY, {
    variables: { postId },
    fetchPolicy: 'cache-and-network',
    skip: !postId,
  });

  if (loading && !data)
    return <div className="PERF PERF--state">Loading performance…</div>;
  if (error || !data?.getPostPerformance) {
    return <div className="PERF PERF--state">Couldn't load performance.</div>;
  }

  const { current, series } = data.getPostPerformance;
  // Day-over-day reach delta between the two most recent snapshots. Snapshot
  // values ONLY (not the live `current`) so the two operands share units — mixing
  // the live counter with a snapshot boundary would misstate the change. Needs ≥2
  // snapshots; otherwise no baseline → em-dash.
  const trend =
    series.length >= 2
      ? series[series.length - 1].reachCount -
        series[series.length - 2].reachCount
      : null;

  const tiles: Array<[string, number]> = [
    ['Reach', current.reachCount],
    ['Likes', current.likeCount],
    ['Bookmarks', current.bookmarkCount],
    ['Replies', current.replyCount],
  ];

  const trendValue =
    trend === null ? DASH : trend >= 0 ? `+${trend}` : String(trend);

  return (
    <div className="PERF">
      <ul className="PERF__tiles">
        {tiles.map(([label, value]) => (
          <li key={label} className="PERF__tile">
            <span className="PERF__value">{value}</span>
            <span className="PERF__label">{label}</span>
          </li>
        ))}
      </ul>
      <p className="PERF__trend">{`Reach since yesterday: ${trendValue}`}</p>
    </div>
  );
}
